export { MAP_LAYER } from 'components/Map/hooks/useLayerStyles/constants';

// Mirrors --map-flight-path-rate-{low,medium}-max-gal-per-ac in
// src/styles/themes/default/colors.scss. Kept here (not read from CSS)
// because getCSSValue runs before the theme stylesheet is attached.
export const RATE_BUCKET_LOW_MAX_GAL_PER_AC = 2;

export const RATE_BUCKET_MEDIUM_MAX_GAL_PER_AC = 4;
